//Standard Confirmation Modal to use throughout the site.
import { useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap';

const ConfirmationModal = ({
	showModal,
	setShowModal,
	cancelButton,
	cancelText,
	confirmAction,
	confirmText,
	message,
	title,
	confirmButtonVariant,
	cancelButtonVariant,
	confirmSuccess,
	confirmFailure,
	successMessage = 'It worked!',
	failureMessage = 'Oops, something went wrong. Please try again.',
	callback,
	useTimeout,
}) => {
	useEffect(() => {
		if (useTimeout) {
			let timer;
			if (confirmSuccess || confirmFailure) {
				timer = setTimeout(() => {
					callback();
					setShowModal(false);
				}, [5000]);
			}
			return () => clearTimeout(timer);
		}
	}, [confirmSuccess, confirmFailure, useTimeout]);

	return (
		<Modal
			show={showModal}
			fullscreen="sm-down"
			onHide={() => {
				setShowModal(false);
				callback();
			}}
		>
			<Modal.Header closeButton>
				<Modal.Title>{title}</Modal.Title>
			</Modal.Header>

			<Modal.Body>
				{(confirmSuccess && successMessage) ||
					(confirmFailure && failureMessage) ||
					message}
			</Modal.Body>
			<Modal.Footer>
				{!confirmSuccess && !confirmFailure && (
					<>
						<Button
							variant={cancelButtonVariant || 'secondary'}
							onClick={() => setShowModal(false)}
						>
							{cancelText || 'Cancel'}
						</Button>
						<Button
							variant={confirmButtonVariant || 'primary'}
							onClick={confirmAction}
						>
							{confirmText || 'Confirm'}
						</Button>
					</>
				)}
			</Modal.Footer>
		</Modal>
	);
};
export default ConfirmationModal;
